module.exports = __webpack_public_path__ + "static/media/table-view-dark.a63562d3.svg";